import { render, staticRenderFns } from "./Spla.vue?vue&type=template&id=3f2d5519&"
import script from "./Spla.vue?vue&type=script&lang=js&"
export * from "./Spla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports